<template>
  <div class="container">
    <div class="box-p">
      <div class="title">验证手机号码</div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="phone"
          type="tel"
          maxlength="11"
          name="手机号"
          placeholder="请输入手机号"
          center
          clearable
        />
        <van-field
          v-model="verifyCode"
          type="digit"
          maxlength="6"
          name="验证码"
          center
          placeholder="请输入验证码"
        >
          <template #button>
            <div class="sendSms" :style="{color:(btnColor ? btnColor:'#f05259')}" @click="getCode"
                 v-if="showFont">获取验证码
            </div>
            <div class="sendSms" :style="{color:(btnColor ? btnColor:'#f05259')}" v-else>
              {{count}}s之后重新发送
            </div>
          </template>
        </van-field>
        <van-field
          v-model="password"
          type="password"
          name="旧密码"
          placeholder="请输入密码(6-15位，区分大小写)"
          center
          clearable
        />
        <van-field
          v-model="verifyPassword"
          type="password"
          name="新密码"
          placeholder="请再次输入密码"
          center
          clearable
        />
        <div style="margin: 50px 16px 0 16px">
          <van-button block type="info" native-type="submit" color="#010212" size="large"
                      :disabled="phone&&phone.length==11&&verifyCode&&password&&verifyPassword&&!isDisable?false:true">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <van-dialog
      v-model="regShow"
      show-cancel-button
      title="温馨提示"
      message=""
      confirm-button-text="我已同意"
      confirm-button-color="#1989fa"
      cancel-button-text="我不同意"
      cancel-button-color="#666"
      @confirm="clickConfirm"
      @cancel="clickCancel">
      <div class="reg-box">
        <p>在您注册和登录产品账号的过程中，您需要完成流程并确认同意<span class="org" @click="goPage('服务协议')">《服务协议》</span>和<span
          class="org" @click="goPage('隐私政策')">《隐私政策》</span>（以下简称“法律文件”）。</p>
        <p>
          请您在确认同意之前务必仔细阅读、充分理解法律文件中的条款内容，尤其是法律文件中粗体标识的部分。如果您不同意上述法律文件或其中的任何条款，请您停止注册或登录。如果您同意上述法律文件，请您阅读和确认同意法律文件并按照正常登录注册流程完成</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
  import mobileType from '../../utils/mobileType';
  import util from '../../utils/util';
  import { getActivityInfo } from '@/apis/activity/common';
  import md5 from 'js-md5';
  import {
    getSmsCodeSJ,
    registerSJ,
  } from '@/apis/common';
  import * as hex from '../../utils/hex_md5';

  export default {
    data() {
      return {
        paramsData: {},
        params: {
          channel: '1020000000',
          deviceId: util.getUUID(),
          platform: 4,
          softVersion: '4.7.8',
          sysVersion: 'TNY-AL00,10',
          token: '',
          areaCode: '',
        },
        phone: '',
        verifyCode: '',
        password: '',
        verifyPassword: '',
        btnColor: '',
        showFont: true,
        count: '',
        timer: null,
        smsType: 0,//业务类型 0 注册 1 修改密码 2 绑卡 3 修改手机号 4 司机注销
        regShow: true,//协议
        userInfoDjsj: {},
        activityName: this.$route.query.activityName,
        isDisable: false,
      };
    },
    created() {
      //Vue的方法给原生调用，则需要把方法挂在Window下面
      window.getDataFromNative = this.getDataFromNative;
    },
    mounted() {
      let userInfoDjsj = this.$storage.getSession('userInfoDjsj');
      if (userInfoDjsj) {
        this.userInfoDjsj = userInfoDjsj;
        this.params.areaCode = userInfoDjsj.cityCode;
      }
      this.paramsData = this.$apiFun.getPlatFromParams(this.$route.query);
      if (this.paramsData) {
        this.getDataFromNative();
      } else {
        this.$apiFun.getUserInfoFromApp();
      }
    },
    methods: {
      // APP交互后获取params IosAndroid必须用这个方法名定义的哦，和挂载的要一样才行~所以所小程序的也噌用它的方法名为保统一
      getDataFromNative(params) {
        if (params) {
          this.paramsData = this.$apiFun.getParamsIosAndroid(params, this.$route.query);
        }
        console.log(this.paramsData, '平台获取到的公参与入参');
        console.log(this.paramsData.params.areaCode, '平台获取到的公参与入参');
      },
      goPage(val) {
        if (val == '服务协议') {
          this.$router.push('/home/serviceAgreement');
        } else if (val == '隐私政策') {
          this.$router.push('/home/privacyPolicy');
        } else {
        }
      },
      clickConfirm() {
      },
      clickCancel() {
        this.$router.go(-1);//返回上一层
      },
      onSubmit(values) {
        const reg = /^1[3456789]\d{9}$/;
        if (this.phone) {
          if (!reg.test(this.phone)) {
            return this.$toast('请输入正确手机号');
          }
        } else {
          return this.$toast('请输入手机号');
        }
        this.sendLogin();
      },
      async sendLogin() {
        let params = {
          channel: this.params.channel,
          deviceId: this.params.deviceId,
          platform: this.params.platform,
          softVersion: this.params.softVersion,
          sysVersion: this.params.sysVersion,
          token: null,
          areaCode: this.paramsData.params.areaCode ? this.paramsData.params.areaCode : this.params.areaCode,
          data: {
            phone: this.phone,
            verifyCode: this.verifyCode,
            password: hex.hex_md5(encodeURIComponent(this.password)),
            verifyPassword: hex.hex_md5(encodeURIComponent(this.verifyPassword)),
          },
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await registerSJ(params);
          if (data.code == 1) {
            this.isDisable = true;
            setTimeout(() => {
              this.isDisable = false;   //点击一次时隔三秒后才能再次点击
            }, 3000);
            let userInfoDjsj = JSON.parse(data.data);
            if (!this.activityName) {
              userInfoDjsj.cityCode = this.userInfoDjsj.cityCode;
            }
            this.$storage.setSession('userInfoDjsj', userInfoDjsj);
            if (this.activityName == 'goBack') {
              this.$router.go(-1);//返回上一层
            } else {
              this.getActivityInfoFun(userInfoDjsj.driverId);
            }
          } else {
            this.isDisable = false;   //点击一次时隔两秒后才能再次点击
            this.$toast(data.msg);
          }
        } catch (error) {
        }
      },
      // 查询活动信息
      async getActivityInfoFun(driverId) {
        let params = { ...this.paramsData.params };
        let paramsOther = this.paramsData.paramsOther;
        let shareParam = paramsOther.shareParam ? JSON.parse(decodeURIComponent(this.$route.query.shareParam)) : {};
        params.data = util.filterParams({
          activityId: this.userInfoDjsj.activityId ? this.userInfoDjsj.activityId : paramsOther.activityId,
          distributionCode: paramsOther.outreachChannelCode,
          cityCode: this.userInfoDjsj.cityCode ? this.userInfoDjsj.cityCode : null,
          driverId: driverId,
          realChannelId: shareParam.realChannelId,
        });
        params.data = JSON.stringify(params.data);
        try {
          const data = await getActivityInfo(params);
          if (data.code == 1) {
            if (this.activityName == 'goBack') {
              // this.$router.push({
              //   path: '/home/myReward',
              //   query: this.$route.query,
              // });
              this.$router.go(-1);//返回上一层
            } else {
              if (this.userInfoDjsj.platform == 3 || params.platform == 3) {
                this.$toast({
                  duration: 3000, // 持续展示 toast
                  message: '恭喜您成功参加活动，请到app store或应用商店下载万顺代驾司机app查看吧～'
                });
              } else {
                if (mobileType.isIOS()) {
                  window.location.href = 'https://apps.apple.com/cn/app/万顺叫车/id1526105345';
                } else if (mobileType.isAndroid()) {
                  window.location.href = 'https://android.myapp.com/myapp/detail.htm?apkName=com.wsecar.designateddriver';
                }
              }
            }
          } else {
            this.$toast(data.msg);
          }
        } catch (error) {
        }
      },
      //发送验证码
      getCode() {
        const reg = /^1[3456789]\d{9}$/;
        if (this.phone) {
          if (!reg.test(this.phone)) {
            return this.$toast('请输入正确手机号');
          }
        } else {
          return this.$toast('请输入手机号');
        }

        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.showFont = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.showFont = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        this.sendSms();

      },
      async sendSms() {
        let params = {
          channel: this.params.channel,
          deviceId: this.params.deviceId,
          platform: this.params.platform,
          softVersion: this.params.softVersion,
          sysVersion: this.params.sysVersion,
          token: null,
          areaCode: this.paramsData.params.areaCode ? this.paramsData.params.areaCode : this.params.areaCode,
          data: {
            phone: this.phone,
            smsType: this.smsType,//业务类型 0 注册 1 修改密码 2 绑卡 3 修改手机号 4 司机注销
          },
        };
        params.data = JSON.stringify(params.data);
        try {
          const data = await getSmsCodeSJ(params);
          if (data.code == 1) {
            this.$toast(data.msg);
          } else {
            this.$toast(data.msg);
          }
        } catch (error) {
        }
      }
    },
  };
</script>
<style scoped lang="less">
  .box-p {
    padding: 0 20px;

    .van-cell::after {
      border-bottom: 1px solid #EBEBEB;
    }

    .title {
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      margin: 30px 12px 100px 12px;
    }
  }

  .reg-box {
    padding: 20px;

    p {
      line-height: 22px;
      font-size: 14px;
    }
  }

</style>

